module.exports = __webpack_public_path__ + "static/media/energy-icon.97132d10.svg";